<template>
	<div class="check-contenido">
		<p class="check-titular">{{titulo}} <button @click="quitarPonerTodos" class="btn-todos">{{ quitar_poner_todos }}</button></p>
		<div class="checkbox-list">
      <div class="contenedor-1-barra" v-for="opcion in datos" :key="opcion.nombre">
          <label class="checkbox checkbox-con-barra" >
              <input type="checkbox" :value="opcion.nombre" v-model="checkeados">  
              <span class="label-checkbox"></span>
          </label>
          <div class="indicador-barra" v-bind:class="{'no-seleccionado': !checkeados.includes(opcion.nombre)}">
              <div class="titulobarra" >{{opcion.nombre}}</div>
                <div class="barra-y-cantidad" >
                  <div class="barra" :style="{
                  width:`${proporcionBarras ? proporcionBarras[opcion.nombre]:0}%`,
                  backgroundColor: variables[0].color
                  }"></div>
                <span class="cantidad" :style="{left:`${proporcionBarras ? proporcionBarras[opcion.nombre]:0}%`}">{{opcion.cantidad.toLocaleString()}}</span>
              </div>
          </div>
      </div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'CheckBarras',
	props: {
        datos:Array,
        variables: Array,
        nombre_variables:Object,
		titulo: String,
		opciones: Array,
		variable_store: String,
		funcion_store: String
	},
	data(){
		return {
            cambio: 1,
			quitar_poner_todos: "Quitar todos"
		}
	},
    watch:{
			
			datos(){
                //this.checkeados = this.datos.map((d) => d.nombre)

            }
    },
	mounted() {

		//this.checkeados = this.datos.map((d) => d.nombre)
	},
	methods: {
		quitarPonerTodos() {
			if(this.quitar_poner_todos == "Quitar todos"){
				this.quitar_poner_todos = "Poner todos";
				this.checkeados = []
			}
			else{
				this.quitar_poner_todos = "Quitar todos";
				this.checkeados = this.datos.map((d) => d.nombre)
			}
		},
	},
	computed: {
		checkeados: {
			get() {
				return this.$store.state[this.variable_store]
			},
			set(value) {
				this.$store.commit(this.funcion_store, value);
			}
		},
        proporcionBarras() {
            let max = Math.max(...this.datos.map((d) => d.cantidad));
            if(max == 0){
              return 0
            }
            else{
              return Object.fromEntries(this.datos.map((d) => [d.nombre, 1 * 100 * d.cantidad /max]))
            }
        }
	},	
}
</script>

<style scoped lang="scss">
$padding: $gap * .5;

.check-contenido {
  flex: 1 0;
  padding: $padding*.5 $padding;
  border-bottom: solid 1px #000;
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    margin-bottom: $padding*.5;

  }
}

.btn-todos {
	background: #fff;
	border: 1px solid #000;
	color: #000;
	font-size: 12px;
	padding: 0 5px;
	margin: 0;
	float: right;
	transition: background-color .3s ease-in-out, color .3s ease-in-out;
	&:hover,
	&:focus {
		background: #000;
		color: #fff;
	}
}
p.check-titular{
  display: flex;
  button{
    margin-left: auto;
    min-width: 90px;
    max-height: 22px;
  }
}
.checkbox-list {
  .contenedor-1-barra {
    position: relative;
    .checkbox-con-barra {
      width: 100%;
      margin: 5px 0;
      z-index: 2;
      .label-checkbox {
        display: none;
      }
    }
  
    .indicador-barra {
      position: absolute;
      width: calc(100% - 80px); //el ultimo 2em sirve para dejarle espacio al texto de la cantidad
      top: 0px;
      left: calc(36px + .5em);
      &.no-seleccionado {
        top: 6px;
      }
      .titulobarra {
        font-size: 12px;
        line-height: 14px;
        margin:0;
      }
      .barra-y-cantidad {
        width: 100%;
        .barra {
          display: inline-block;
          background-color: blue;
          height: 12px;
        }
        .cantidad {
          margin-left: .5em;
          font-size: 12px;
          line-height: 12px;
          position: absolute;
        }
      }
    }
  }
}

</style>
